import Fuse from "fuse.js";

export default class FuseSearch {
	constructor(options) {
		this.options = options;
	}

	setTransactions(list) {
		this.searcher = new Fuse(list, this.options);
	}

	async search(query) {
		return new Promise((resolve, reject) => {
			const results = this.searcher.search(query);
			const processed = this.processResults(results);
			resolve(processed);
		});
	}

	processResults(searchResults) {
		return searchResults.slice(0, 100).map((result) => {
				const returnData = {
					...result.item,
					score: result.score
				};
				return returnData;
			})
			.filter((result) => {
				return result.score <= 0.5;
			})
			.map((result) => {
				return result.transaction;
			});
	}
}
